import { tv } from "tailwind-variants";

export const layer = tv({
    base: [],

    variants: {
        layer: {
            "high-alert": "",
            "modal": "",
            "navigation": "",
            "overlay": "",
            "icons": "",
            "base": ""
        },
        layerAbove: {
            false: "",
            true: ""
        },
        force: {
            false: "",
            true: ""
        }
    },

    compoundVariants: [
        // DEFAULT LAYERS - default
        {
            layer: "high-alert",
            layerAbove: false,
            force: false,
            class: "tw:layer-high-alert/[0]"
        },
        {
            layer: "modal",
            layerAbove: false,
            force: false,
            class: "tw:layer-modal/[0]"
        },
        {
            layer: "navigation",
            layerAbove: false,
            force: false,
            class: "tw:layer-navigation/[0]"
        },
        {
            layer: "overlay",
            layerAbove: false,
            force: false,
            class: "tw:layer-overlay/[0]"
        },
        {
            layer: "icons",
            layerAbove: false,
            force: false,
            class: "tw:layer-icons/[0]"
        },
        {
            layer: "base",
            layerAbove: false,
            force: false,
            class: "tw:layer-base/[0]"
        },

        // INCREASED LAYERS - default
        {
            layer: "high-alert",
            layerAbove: true,
            force: false,
            class: "tw:layer-high-alert/[1]"
        },
        {
            layer: "modal",
            layerAbove: true,
            force: false,
            class: "tw:layer-modal/[1]"
        },
        {
            layer: "navigation",
            layerAbove: true,
            force: false,
            class: "tw:layer-navigation/[1]"
        },
        {
            layer: "overlay",
            layerAbove: true,
            force: false,
            class: "tw:layer-overlay/[1]"
        },
        {
            layer: "icons",
            layerAbove: true,
            force: false,
            class: "tw:layer-icons/[1]"
        },
        {
            layer: "base",
            layerAbove: true,
            force: false,
            class: "tw:layer-base/[1]"
        },

        // DEFAULT LAYERS - force
        {
            layer: "high-alert",
            layerAbove: false,
            force: true,
            class: "tw:layer-high-alert/[0]!"
        },
        {
            layer: "modal",
            layerAbove: false,
            force: true,
            class: "tw:layer-modal/[0]!"
        },
        {
            layer: "navigation",
            layerAbove: false,
            force: true,
            class: "tw:layer-navigation/[0]!"
        },
        {
            layer: "overlay",
            layerAbove: false,
            force: true,
            class: "tw:layer-overlay/[0]!"
        },
        {
            layer: "icons",
            layerAbove: false,
            force: true,
            class: "tw:layer-icons/[0]!"
        },
        {
            layer: "base",
            layerAbove: false,
            force: true,
            class: "tw:layer-base/[0]!"
        },

        // INCREASED LAYERS - force
        {
            layer: "high-alert",
            layerAbove: true,
            force: true,
            class: "tw:layer-high-alert/[1]!"
        },
        {
            layer: "modal",
            layerAbove: true,
            force: true,
            class: "tw:layer-modal/[1]!"
        },
        {
            layer: "navigation",
            layerAbove: true,
            force: true,
            class: "tw:layer-navigation/[1]!"
        },
        {
            layer: "overlay",
            layerAbove: true,
            force: true,
            class: "tw:layer-overlay/[1]!"
        },
        {
            layer: "icons",
            layerAbove: true,
            force: true,
            class: "tw:layer-icons/[1]!"
        },
        {
            layer: "base",
            layerAbove: true,
            force: true,
            class: "tw:layer-base/[1]!"
        }
    ],

    defaultVariants: {
        layerAbove: false,
        force: false
    }
});
